import { useEffect, useState } from 'react'

import { BUTTON_TYPES, LinkButton } from 'components/Buttons'
import MenuIcon from 'public/assets/navbar/icon-menu.svg'
import ShareIcon from 'public/assets/social/icon-share.svg'

import css from './FixedFooter.module.css'

export type FixedFooterProps = {
    onMenuClick: () => void
    title: string
    text: string
    url: string
}

function FixedFooter({ onMenuClick, title, text, url }: FixedFooterProps) {
    const [canShare, setSharability] = useState(false)
    const sharePost = () => navigator.share({ title, text, url })

    /** Contents must be served over HTTPS for Share API to work (can test with ngrok) */
    useEffect(() => setSharability(navigator && Boolean(navigator.share)), [])

    return (
        <div className={css.fixedFooter}>
            <LinkButton href="#subscribe" type={BUTTON_TYPES.XS_INVERTED}>
                Subscribe
            </LinkButton>

            <div className={css.iconsContainer}>
                {canShare && <ShareIcon onClick={() => sharePost()} />}
                <button
                    id="ga-tw-rwg-mobile-toc"
                    aria-label="Open table of contents"
                    onClick={onMenuClick}
                >
                    <MenuIcon />
                </button>
            </div>
        </div>
    )
}

export default FixedFooter
